module.exports = __webpack_public_path__ + "img/20190809161841387.48b40ad4.png";